import React from 'react';
import PropTypes from 'prop-types';
import { PayerSelectDrawer } from '@sde/widgets-core/src/widgets/PayerSelectDrawer';
import { getQueryParam } from '@sde/widgets-core/src/tools/url';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { event } from '@uhg-abyss/web/tools/event';

export const PayerSelectDrawerWidget = ({
  payer,
  setPayer,
  isPayerOpen,
  togglePayer,
}) => {
  const { payerId } = getQueryParam();
  const { getLocation } = useRouter();
  const pathName = getLocation().pathname;
  const applicationName = pathName.split('/')[1];

  const payerSelectProps = {
    data: {
      title: '',
      payerId: payerId || payer.payerId,
      application: ['referral', 'feeschedulelookup'].includes(applicationName)
        ? applicationName
        : '',
      togglePayer,
      isPayerOpen,
    },
    events: {
      onChange: (data) => {
        event.setData({
          payerId: data.payerId,
          payerName: data.payerName,
          payerLabel: data.payerLabel,
        });
        setPayer(data);
      },
      changePayerStartEvent: () => {
        event('CHANGE_PAYER');
      },
      onSave: (data) => {
        togglePayer(false);
        event('CHANGE_PAYER_COMPLETION');
      },
      onCancel: () => {},
      onDrawerClose: () => {
        togglePayer(false);
      },
    },
  };

  return <PayerSelectDrawer {...payerSelectProps} />;
};

PayerSelectDrawerWidget.propTypes = {
  payer: PropTypes.shape({
    payerId: PropTypes.string,
  }).isRequired,
  setPayer: PropTypes.func.isRequired,
  isPayerOpen: PropTypes.bool.isRequired,
  togglePayer: PropTypes.func.isRequired,
};
